/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function shouldSkipAggressiveImagePreload() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) return false;

    if (connection.saveData) return true;

    const effectiveType = String(connection.effectiveType || '').toLowerCase();
    return effectiveType === 'slow-2g' || effectiveType === '2g' || effectiveType === '3g';
  }

  if (shouldSkipAggressiveImagePreload()) {
    window.fastNetworkAndCPU = false;
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!document.body.classList.contains('template-collection')) return;

    const list = document.querySelector('.collection__filter-tags');
    if (!list) return;

    const items = list.querySelectorAll('li');
    if (items.length < 3) return;

    const lastItem = items[items.length - 1];
    const thirdItem = items[2];
    list.insertBefore(lastItem, thirdItem);
  });

  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

  const productSectionSelectors = [
    '[data-section-type="product-template"][data-section-id]',
    '[data-section-type="featured-product"][data-section-id]',
  ];

  const selectors = {
    siblingsLink: 'a.siblings__swatch',
  };

  const classes = {
    siblingsLoading: 'siblings--loading',
  };

  function isPlainLeftClick(event) {
    return (
      event.button === 0 &&
      !event.metaKey &&
      !event.ctrlKey &&
      !event.shiftKey &&
      !event.altKey
    );
  }

  function shouldHandleSiblingsNavigation(event) {
    if (event.type === 'click') {
      return isPlainLeftClick(event);
    }

    if (event.type === 'keydown') {
      return event.key === 'Enter' || event.key === ' ';
    }

    return false;
  }

  function getProductSectionSelector(sectionId) {
    if (!sectionId) return productSectionSelectors.join(', ');

    return productSectionSelectors
      .map((selector) => `${selector}[data-section-id="${sectionId}"]`)
      .join(', ');
  }

  function findProductSection(root = document, sectionId = '') {
    const selector = getProductSectionSelector(sectionId);

    if (root instanceof Element && root.matches(selector)) {
      return root;
    }

    return root.querySelector(selector);
  }

  function getProductSectionType(productSection) {
    return productSection?.getAttribute('data-section-type') || 'product-template';
  }

  function buildSectionUrl(url, sectionId) {
    try {
      const nextUrl = new URL(url, window.location.origin);
      nextUrl.searchParams.set('section_id', sectionId);
      return nextUrl.toString();
    } catch (e) {
      // Fallback for unexpected URL parsing issues
      const joiner = url.includes('?') ? '&' : '?';
      return `${url}${joiner}section_id=${encodeURIComponent(sectionId)}`;
    }
  }

  function getCurrentVariantFromProductSection(productSection) {
    try {
      const productJsonEl = productSection.querySelector('[data-product-json]');
      if (!productJsonEl) return null;

      const product = JSON.parse(productJsonEl.textContent || '{}');
      const variantId = productSection.querySelector('input[name="id"]')?.value;

      if (!product?.variants || !Array.isArray(product.variants)) return null;
      if (variantId) {
        const match = product.variants.find((v) => String(v?.id) === String(variantId));
        if (match) return match;
      }

      return product.variants[0] || null;
    } catch (e) {
      return null;
    }
  }

  function dispatchVariantChange(productSection) {
    const variant = getCurrentVariantFromProductSection(productSection);
    if (!variant) return;

    productSection.dispatchEvent(
      new CustomEvent('theme:variant:change', {
        detail: {variant},
        bubbles: true,
      })
    );
  }

  function getKlarnaLocale() {
    return (
      document.documentElement.getAttribute('lang') ||
      window.Shopify?.locale ||
      window.Shopify?.country?.locale ||
      ''
    );
  }

  function ensureKlarnaLocale(root = document) {
    const locale = getKlarnaLocale();
    if (!locale) return;

    root.querySelectorAll('klarna-placement').forEach((el) => {
      const hasLocale = el.hasAttribute('data-locale') || el.hasAttribute('locale');
      if (!hasLocale) el.setAttribute('data-locale', locale);
    });
  }

  function refreshThirdPartyWidgets(productSection) {
    // Let app embeds/widgets know we've swapped a PDP section via AJAX.
    dispatchVariantChange(productSection);

    // Klarna Onsite Messaging typically needs an explicit refresh after dynamic DOM swaps.
    ensureKlarnaLocale(document);
    try {
      window.KlarnaOnsiteMessaging?.refresh?.();
    } catch (e) {}
    try {
      window.Klarna?.OnsiteMessaging?.refresh?.();
    } catch (e) {}
  }

  async function swapProductSection(nextUrl, {updateHistory = true} = {}) {
    const currentSection = findProductSection(document);
    if (!currentSection) return false;

    const sectionId = currentSection.getAttribute('data-section-id');
    if (!sectionId) return false;
    const sectionType = getProductSectionType(currentSection);

    const scrollY = window.scrollY;
    const fetchUrl = buildSectionUrl(nextUrl, sectionId);

    currentSection.classList.add(classes.siblingsLoading);
    document.documentElement.classList.add(classes.siblingsLoading);

    try {
      const res = await fetch(fetchUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);

      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incomingSection = findProductSection(parsed, sectionId) || findProductSection(parsed);
      if (!incomingSection) throw new Error('Missing incoming product section');

      // Unload current section JS just before swapping DOM
      window.Shopify?.theme?.sections?.unload?.(currentSection);

      currentSection.replaceWith(incomingSection);

      const mountedSection = findProductSection(document, sectionId);
      if (mountedSection) {
        // Re-run inline scripts inside the swapped section (app blocks often rely on these)
        mountedSection.querySelectorAll('script:not([src])').forEach((oldScript) => {
          const type = (oldScript.getAttribute('type') || '').toLowerCase();
          if (type === 'application/json' || type === 'application/ld+json') return;

          const newScript = document.createElement('script');
          // Preserve type if present (e.g. "application/javascript")
          if (oldScript.type) newScript.type = oldScript.type;
          newScript.text = oldScript.textContent || '';
          oldScript.replaceWith(newScript);
        });

        window.Shopify?.theme?.sections?.load?.(sectionType, mountedSection);

        // Re-initialize/refresh third-party widgets that don't automatically detect DOM swaps
        refreshThirdPartyWidgets(mountedSection);
      }

      if (updateHistory) {
        history.pushState({ajaxSiblings: true, url: nextUrl}, '', nextUrl);
      }

      // Preserve scroll position to avoid "page reload" feeling
      requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
      });

      return true;
    } catch (e) {
      // If anything goes wrong, fall back to normal navigation
      window.location.href = nextUrl;
      return false;
    } finally {
      const mountedSection = findProductSection(document, sectionId);
      mountedSection?.classList.remove(classes.siblingsLoading);
      document.documentElement.classList.remove(classes.siblingsLoading);
    }
  }

  function handleSiblingsNavigation(event) {
    const link = event.target.closest(selectors.siblingsLink);
    if (!link) return;

    if (!shouldHandleSiblingsNavigation(event)) return;

    const href = link.getAttribute('href');
    if (!href) return;

    event.preventDefault();
    event.stopPropagation();
    // Prevent other click handlers from forcing navigation
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    swapProductSection(href, {updateHistory: true});
  }

  document.addEventListener('click', handleSiblingsNavigation, true);
  document.addEventListener('keydown', handleSiblingsNavigation, true);

  // One-time: ensure Klarna placements have locale on initial page load too
  ensureKlarnaLocale(document);

  window.addEventListener('popstate', (event) => {
    // If user navigates back/forward within our AJAX sibling swaps, keep it SPA-like
    if (event.state?.ajaxSiblings && typeof event.state.url === 'string') {
      swapProductSection(event.state.url, {updateHistory: false});
    }
  });

  // Directly close a filter dropdown without triggering events or animations
  function closeFilterDropdown(trigger) {
    var dropdownId = trigger.getAttribute('aria-controls');
    var dropdown = dropdownId ? document.getElementById(dropdownId) : null;
    trigger.setAttribute('aria-expanded', 'false');
    trigger.classList.remove('is-expanded');
    if (dropdown) {
      dropdown.setAttribute('aria-expanded', 'false');
      dropdown.classList.remove('is-expanded');
      dropdown.style.height = '0px';
    }
  }

  function closeAllFilterDropdowns() {
    document.querySelectorAll('[data-collection-filters-list] .collection__filter [data-collapsible-trigger][aria-expanded="true"]').forEach(function(trigger) {
      closeFilterDropdown(trigger);
    });
  }

  // Close all filters on initial page load (before first browser paint)
  closeAllFilterDropdowns();

  // Close all filters after AJAX filter re-render
  document.addEventListener('theme:filters:init', closeAllFilterDropdowns);

  // Collapse the specific filter dropdown immediately after selecting an option
  document.addEventListener('click', function(e) {
    var tag = e.target.closest('[data-collection-filters-list] .collection__filter-tag');
    if (!tag) return;
    var filter = tag.closest('.collection__filter');
    if (!filter) return;
    var trigger = filter.querySelector('[data-collapsible-trigger][aria-expanded="true"]');
    if (trigger) closeFilterDropdown(trigger);
  });

  // Collapse all open filter dropdowns when clicking outside the filter bar
  document.addEventListener('click', function(e) {
    var filtersBar = document.querySelector('[data-collection-filters-list]');
    if (!filtersBar || filtersBar.contains(e.target)) return;
    closeAllFilterDropdowns();
  }, true);

  // Ensure compact sticky navbar appears when scrolling on collection/search pages.
  // The theme originally disabled compact-header behavior when collection filters were
  // present (hasCollectionFilters check), but that was commented out. However the
  // theme's own scroll handling is still unreliable here, so we drive it directly.
  (function() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var _offset;
    function getOffset() {
      if (_offset !== undefined) return _offset;
      var h = parseInt(header.dataset.height || '') || header.offsetHeight || 60;
      var ann = document.querySelector('[data-announcement-bar]');
      _offset = h + (ann ? ann.offsetHeight : 0);
      return _offset;
    }

    function syncNavbar() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > getOffset()) {
        document.body.classList.add('has-scrolled');
        document.body.classList.remove('hide-header');
      } else {
        document.body.classList.remove('has-scrolled');
        document.body.classList.remove('hide-header');
      }
    }

    // Run in the same rAF batch as the theme's scroll handler (which also uses rAF).
    // Since custom.js loads after theme.js, our rAF queues after theirs and wins.
    window.addEventListener('scroll', function() {
      requestAnimationFrame(syncNavbar);
    }, { passive: true });

    // Sync once on load in case page is restored mid-scroll
    syncNavbar();
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
